import { http } from '@/plugins/http'
import type DataResponse from '@/types/DataResponse'
import type SectionGrid from '@/types/SectionGrid'
import type { SectionGridPayload } from '@/types/SectionGrid'

export default class SectionService {
  async seats(id: string) {
    return await http.get<DataResponse<SectionGrid>>(`/api/v1/office/sections/${id}/seats`)
  }

  /** Saves the whole grid at once; a 422 means nothing was saved */
  async saveSeats(id: string, payload: SectionGridPayload) {
    return await http.put<DataResponse<SectionGrid>>(`/api/v1/office/sections/${id}/seats`, payload)
  }

  async destroy(id: string) {
    return await http.delete(`/api/v1/office/sections/${id}`)
  }
}
